import CapitalAutoCollectedBanner from '@di-shared/features/capital/CapitalAutoCollectedBanner';
import CapitalContents from '@di-shared/features/capital/CapitalContents';
import useFirebaseStore from '@di-shared/features/environment/firebaseStore';
import PublicServiceContents from '@di-shared/features/public-service/PublicServiceContents';

export interface FinanceContentsProps {
  vin: string;
}

function FinanceContents({vin}: FinanceContentsProps): JSX.Element {
  const {resolveFeatureFlag} = useFirebaseStore((state) => ({resolveFeatureFlag: state.resolveFeatureFlag}));
  const isMobilityConsumptionVisible = resolveFeatureFlag('KR_MOBILITY_CONSUMPTION', vin);

  return (
    <div className="tab_content car_maintenance">
      {isMobilityConsumptionVisible && <CapitalAutoCollectedBanner />}
      <CapitalContents
        vin={vin}
        isProduction={true}
      />
      <PublicServiceContents vin={vin} />
    </div>
  );
}

export default FinanceContents;
